export const ECurrency = {
  USD: "USD",
  CAD: "CAD",
} as const;
export type ECurrency = (typeof ECurrency)[keyof typeof ECurrency];

export const toDollars = (input: string | number | null | undefined) =>
  (Number(input) / 100).toLocaleString("en", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
export const toDecimal = (input: string | number | null | undefined) =>
  (Number(input) / 100).toFixed(2);
export const toCents = (input: string | number | null | undefined) =>
  Number(input) * 100;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNumber = (num: any) =>
  !Number.isNaN(parseFloat(num)) && Number.isFinite(num);

export const getUSDollarFormat = (number?: number) =>
  number
    ? number.toLocaleString("en-US", {
        style: "currency",
        currency: ECurrency.USD,
      })
    : `$0.00`;

// TODO: Britt Danzer - June 1st 2023 - Need to clean this function up and toDollars above
export const getUSDollarFormatToDollars = (
  amount?: number | string,
  currency: ECurrency = ECurrency.USD
) =>
  amount || amount === 0
    ? (Number(amount) / 100).toLocaleString("en", {
        style: "currency",
        currency: currency === ECurrency.CAD ? ECurrency.CAD : ECurrency.USD,
      })
    : currency === ECurrency.CAD
    ? "$0.00 CAD"
    : "$0.00";

export const getCentToDollarWSpace = (
  amount?: string | number | null | undefined,
  currency: ECurrency = ECurrency.USD
) => {
  const symbol = "$";
  const currencySuffix = currency === ECurrency.CAD ? " CAD" : "";
  if (amount) {
    const formatted = getUSDollarFormatToDollars(amount, currency)?.replace(
      /^[CA$]*/,
      ""
    );
    return `${symbol} ${formatted}${currencySuffix}`;
  }
  return `${symbol} 0.00${currencySuffix}`;
};

export const getDollarsWSpace = (
  amount?: string | number | null | undefined,
  currency: ECurrency = ECurrency.USD
) => {
  const symbol = "$";
  const currencySuffix = currency === ECurrency.CAD ? " CAD" : "";
  if (amount) {
    const sign = Number(amount) < 0 ? "-" : "";
    const formatted = getUSDollarFormat(Math.abs(Number(amount)))?.replace(
      /^[CA$]*/,
      ""
    );
    return `${sign}${symbol} ${formatted}${currencySuffix}`;
  }
  return `${symbol} 0.00${currencySuffix}`;
};
